export default function useProductsLayout(website: {productsLayout?: string}) {
  if (!website) return 'long'
  return website.productsLayout || 'long'
}
